import React, { Component } from 'react';
import _forEach from 'lodash/forEach';
import I18n from '~/utils/translations';
import FilterIcon from './filter_icon';
import { joinClasses } from '../utils/react';

export default class LocationButtons extends Component {
  render() {
    return (
      <div className="preferences-pane location-preferences">
        <span className="preferences-pane__title">{I18n.t('pages.homes.location_preferences.title')}</span>
        <div className="preferences-pane__row">{this.props.options.map((o) => this.renderOption('location', o))}</div>
      </div>
    );
  }

  renderOption = (key, option) => {
    const buttonClass = this.optionButtonClass(option);

    return (
      <div key={option.value} className="preferences-pane__option">
        <a href={`?city=${option.value}#homes`} className={buttonClass} onClick={this.onClickOption(option.value)}>
          <FilterIcon option={option} selected={this.selected(option)} />
          {option.text}
        </a>
      </div>
    );
  };

  selected(option) {
    return this.props.locationFilter == option.value;
  }

  optionButtonClass = (option) => {
    return joinClasses([
      'preferences-pane__option-button',
      'preferences-pane__option-button--default',
      this.selected(option) && 'preferences-pane__option-button--primary-active',
    ]);
  };

  onClickOption = (value) => (e) => {
    e.preventDefault();
    this.props.onLocationFilterChange(value);
  };
}
